import React from 'react';
export function Comparison() {
  const rows = [{
    sin: 'Bajás el precio cada vez que te comparan con otro veterinario',
    con: 'Guión de 3 pasos para defender tu valor sin ponerte a la defensiva'
  }, {
    sin: 'Improvisás cada consulta difícil y salís agotado/a',
    con: 'Protocolo claro para cada situación — entrás sabiendo qué decir'
  }, {
    sin: 'El propietario no entiende el diagnóstico ni cumple el tratamiento',
    con: 'Técnica de traducción y regla de 3 bloques que genera adherencia real'
  }, {
    sin: 'Las malas noticias te dejan emocionalmente destruido/a',
    con: 'Protocolo SPIKES adaptado al veterinario argentino — sabés exactamente qué hacer'
  }, {
    sin: 'El dueño con el diagnóstico de TikTok te hace perder autoridad',
    con: 'Método de 3 movimientos para redirigir sin confrontar y sin perder credibilidad'
  }, {
    sin: 'Llamadas post-consulta que interrumpen tu tarde',
    con: 'La frase de cierre que elimina el 80% de las llamadas innecesarias'
  }, {
    sin: 'Sin consentimiento informado — sin respaldo ante reclamos',
    con: '5 modelos de consentimiento listos para imprimir o mandar por WhatsApp'
  }, {
    sin: 'Hablar de plata te incomoda y te cuesta dinero',
    con: 'Protocolo de presentación de presupuesto y plantilla profesional lista'
  }];
  return <section className="bg-[#fafafa] py-10 sm:py-16 px-5" data-id="element-35">
      <div className="max-w-6xl mx-auto" data-id="element-36">
        <div className="text-center text-[10px] sm:text-xs font-semibold tracking-[0.14em] uppercase text-green mb-2 sm:mb-3" data-id="element-37">
          La realidad
        </div>
        <h2 className="font-display text-2xl sm:text-4xl lg:text-5xl font-bold text-center text-navy mb-8 sm:mb-12 leading-tight" data-id="element-38">
          ¿Cuánto cuesta NO tenerlo?
        </h2>

        <div className="max-w-4xl mx-auto rounded-xl sm:rounded-2xl overflow-hidden shadow-md sm:shadow-lg" data-id="element-39">
          {/* Header - hidden on mobile */}
          <div className="hidden sm:grid grid-cols-2 bg-gray-200" data-id="element-40">
            <div className="p-4 sm:p-5 font-bold text-sm sm:text-base text-gray bg-[#e8e8e8]" data-id="element-41">
              Sin La Consulta Perfecta
            </div>
            <div className="p-4 sm:p-5 font-bold text-sm sm:text-base text-white bg-green" data-id="element-42">
              Con La Consulta Perfecta
            </div>
          </div>

          {/* Rows */}
          {rows.map((row, i) => <div key={i} className="grid grid-cols-1 sm:grid-cols-2 border-b border-gray-200 last:border-b-0" data-id="element-43">
              <div className="p-3 sm:p-4 text-[11px] sm:text-sm leading-relaxed text-[#e53e3e] bg-[#f8f8f8] sm:bg-[#f1f1f1] even:bg-[#f1f1f1] sm:even:bg-[#f8f8f8] border-t-2 border-[#e53e3e] sm:border-t-0" data-id="element-44">
                <span className="sm:hidden font-bold" data-id="element-45">✗ </span>
                {row.sin}
              </div>
              <div className="p-3 sm:p-4 text-[11px] sm:text-sm leading-relaxed text-green bg-[#f0faf6] even:bg-[#e8f7f0] border-t-2 border-green-light sm:border-t-0" data-id="element-46">
                <span className="font-bold" data-id="element-47">✓ </span>
                {row.con}
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}